var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.004,
    viewBox: "0 0 20 20.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboards",
    transform: "translate(-507.832 -208.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M516.926,213.252c-.015.537.044,1.22-.022,1.9a2.7,2.7,0,0,1-2.692,2.477q-1.83.025-3.66,0a2.715,2.715,0,0,1-2.711-2.732q-.017-1.808,0-3.617a2.713,2.713,0,0,1,2.712-2.731q1.829-.025,3.66,0a2.719,2.719,0,0,1,2.712,2.732C516.933,211.888,516.926,212.5,516.926,213.252Zm-1.819-.157c0-.582,0-1.163,0-1.745a.91.91,0,0,0-.977-.987q-1.745,0-3.49,0a.909.909,0,0,0-.981.982q0,1.745,0,3.489a.908.908,0,0,0,.966.976q1.755,0,3.511,0a.909.909,0,0,0,.971-.971C515.108,214.258,515.106,213.676,515.106,213.094Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M699.763,212.949c.014-.545-.045-1.235.022-1.92a2.694,2.694,0,0,1,2.691-2.478q1.829-.024,3.659,0a2.71,2.71,0,0,1,2.711,2.71q.026,1.829,0,3.66a2.711,2.711,0,0,1-2.71,2.711q-1.829.026-3.66,0a2.719,2.719,0,0,1-2.713-2.731C699.756,214.3,699.763,213.694,699.763,212.949Zm7.268.162c0-.589,0-1.177,0-1.766a.908.908,0,0,0-.965-.977q-1.766,0-3.532,0a.9.9,0,0,0-.95.948q0,1.777,0,3.553a.9.9,0,0,0,.954.945q1.766,0,3.532,0a.907.907,0,0,0,.961-.959C707.033,214.274,707.031,213.692,707.031,213.111Z",
    transform: "translate(-181.027 -0.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M516.926,405.269c-.015.543.044,1.233-.022,1.918a2.7,2.7,0,0,1-2.691,2.478q-1.83.025-3.66,0a2.715,2.715,0,0,1-2.712-2.732q-.017-1.808,0-3.617a2.717,2.717,0,0,1,2.732-2.733q1.808-.018,3.617,0a2.722,2.722,0,0,1,2.734,2.732C516.933,403.919,516.926,404.522,516.926,405.269Zm-4.549,2.58c.589,0,1.177,0,1.766,0a.907.907,0,0,0,.963-.958q0-1.766,0-3.532a.905.905,0,0,0-.963-.957q-1.755,0-3.511,0a.907.907,0,0,0-.973.968q0,1.755,0,3.511a.908.908,0,0,0,.973.969C511.214,407.851,511.8,407.849,512.377,407.849Z",
    transform: "translate(0 -181.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M704.18,409.632c-.549-.015-1.239.044-1.924-.022a2.691,2.691,0,0,1-2.477-2.67q-.03-1.851,0-3.7a2.706,2.706,0,0,1,2.708-2.69q1.829-.025,3.66,0a2.71,2.71,0,0,1,2.711,2.71q.026,1.829,0,3.66a2.719,2.719,0,0,1-2.731,2.714C705.525,409.639,704.922,409.632,704.18,409.632Zm-2.586-4.543c0,.589,0,1.177,0,1.766a.906.906,0,0,0,.963.957q1.766,0,3.532,0a.9.9,0,0,0,.952-.947q0-1.777,0-3.553a.9.9,0,0,0-.953-.946q-1.766,0-3.532,0a.905.905,0,0,0-.962.958C701.592,403.911,701.594,404.5,701.594,405.088Z",
    transform: "translate(-181.039 -181.104)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon1);
export default __webpack_public_path__ + "static/media/sidebar_icon1.b639c7d8f4c4f4e70ebb6852562977db.svg";
export { ForwardRef as ReactComponent };